import { useJobFormContext } from 'parent-portal/forms/JobFormContext';
import { JobFormFields } from 'parent-portal/forms/JobRequestTypes';
import React from 'react';
import { FieldStates } from '../../FormTypes';
import PastProvidersInput from './PastProvidersInput';
import PreferredProvidersInput from './PreferredProvidersInput';
import JobFormPage from '../JobFormPage';
import { Text } from 'library';
import { useUserContext } from 'UserContext';

interface ProviderPreferencesPageProps {
    fieldStates: FieldStates<JobFormFields>;
    title?: string;
    subtitle?: string;
    nextText?: string;
    submit?: () => void;
}

export default function ProviderPreferencesPage({
    fieldStates,
    title,
    subtitle,
    nextText = 'Next',
    submit,
}: ProviderPreferencesPageProps) {
    const { pastProviders, preferredProviders } = fieldStates;
    const { goToNext } = useJobFormContext();
    const { role } = useUserContext();

    function onNextClicked() {
        if (pageIsValid()) {
            if (submit) {
                submit();
            } else {
                goToNext();
            }
        }
    }

    function pageIsValid() {
        return (pastProviders.isValid && preferredProviders.isValid) || role === 'business_active';
    }

    return (
        <JobFormPage
            onNextClicked={onNextClicked}
            title={title ?? 'Request Providers'}
            nextText={nextText}
            subtitle={subtitle}
            nextDisabled={!pageIsValid()}
            id="provider-preferences-page"
        >
            <PastProvidersInput pastProviders={pastProviders} />
            <PreferredProvidersInput preferredProviders={preferredProviders} />
            <div style={{ marginTop: 30 }} />
        </JobFormPage>
    );
}
